// // File Location: src/pages/admin/LeadGeneratorApplicationDetails.jsx

// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import {
//   ArrowLeft,
//   TrendingUp,
//   MapPin,
//   Phone,
//   Mail,
//   Calendar,
//   User,
//   FileText,
//   Download,
//   Eye,
//   X,
//   CheckCircle,
//   XCircle,
//   AlertTriangle,
//   Loader,
//   Send,
//   MessageSquare,
//   Clock,
//   Shield,
//   Users,
//   Activity,
//   CreditCard,
//   Globe,
//   Building2,
//   Briefcase,
//   CheckSquare,
//   Star,
//   ExternalLink,
//   Hash,
//   Building
// } from 'lucide-react';
// import { 
//   getLeadGeneratorApplication, 
//   approveLeadGeneratorApplication, 
//   rejectLeadGeneratorApplication,
//   requestAdditionalDocuments 
// } from '../../services/leadGeneratorService';
// import { useAuth } from '../../context/AuthContext';

// const LeadGeneratorApplicationDetails = () => {
//   const { applicationId } = useParams();
//   const navigate = useNavigate();
//   const { userData } = useAuth();

//   const [application, setApplication] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState({});
//   const [showDocumentModal, setShowDocumentModal] = useState(false);
//   const [selectedDocument, setSelectedDocument] = useState(null);
//   const [showApprovalModal, setShowApprovalModal] = useState(false);
//   const [showRejectionModal, setShowRejectionModal] = useState(false);
//   const [showRequestModal, setShowRequestModal] = useState(false);

//   // Form states
//   const [approvalPassword, setApprovalPassword] = useState('');
//   const [rejectionReason, setRejectionReason] = useState('');
//   const [requestMessage, setRequestMessage] = useState('');
//   const [requestDocuments, setRequestDocuments] = useState([]);

//   // Available document types for requests
//   const availableDocuments = [
//     'Updated CIN Certificate',
//     'Latest KYC Documents',
//     'MOU Agreement Updates',
//     'Business Registration Certificate',
//     'Tax Registration Documents',
//     'GST Certificate',
//     'Additional Bank Documents',
//     'Entity Logo (High Resolution)',
//     'Service Agreement Documents',
//     'Compliance Certificates'
//   ];

//   useEffect(() => {
//     loadApplicationDetails();
//   }, [applicationId]);

//   const loadApplicationDetails = async () => {
//     setLoading(true);
//     try {
//       const result = await getLeadGeneratorApplication(applicationId);
//       if (result.success) {
//         setApplication(result.application);
//       } else {
//         console.error('Error loading application:', result.error);
//       }
//     } catch (error) {
//       console.error('Error loading application details:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApproveLeadGenerator = async () => {
//     if (!approvalPassword.trim()) return;

//     setActionLoading(prev => ({ ...prev, approve: true }));
//     try {
//       const result = await approveLeadGeneratorApplication(
//         applicationId,
//         userData.uid,
//         approvalPassword
//       );

//       if (result.success) {
//         setApplication(prev => ({
//           ...prev,
//           status: 'approved',
//           approvedBy: userData.uid,
//           approvedAt: new Date()
//         }));
//         setShowApprovalModal(false);
//         setApprovalPassword('');
//         alert('Lead Generator approved successfully!');
//       } else {
//         alert('Error approving lead generator: ' + result.error);
//       }
//     } catch (error) {
//       console.error('Error approving lead generator:', error);
//       alert('Failed to approve lead generator');
//     } finally {
//       setActionLoading(prev => ({ ...prev, approve: false }));
//     }
//   };

//   const handleRejectLeadGenerator = async () => {
//     if (!rejectionReason.trim()) return;

//     setActionLoading(prev => ({ ...prev, reject: true }));
//     try {
//       const result = await rejectLeadGeneratorApplication(
//         applicationId,
//         userData.uid,
//         rejectionReason
//       );

//       if (result.success) {
//         setApplication(prev => ({
//           ...prev,
//           status: 'rejected',
//           rejectedBy: userData.uid,
//           rejectedAt: new Date(),
//           rejectionReason
//         }));
//         setShowRejectionModal(false);
//         setRejectionReason('');
//         alert('Lead Generator application rejected.');
//       } else {
//         alert('Error rejecting lead generator: ' + result.error);
//       }
//     } catch (error) {
//       console.error('Error rejecting lead generator:', error);
//       alert('Failed to reject lead generator');
//     } finally {
//       setActionLoading(prev => ({ ...prev, reject: false }));
//     }
//   };

//   const handleRequestAdditionalData = async () => {
//     if (!requestMessage.trim() || requestDocuments.length === 0) return;

//     setActionLoading(prev => ({ ...prev, request: true }));
//     try {
//       const result = await requestAdditionalDocuments(
//         applicationId,
//         userData.uid,
//         requestMessage,
//         requestDocuments
//       );

//       if (result.success) {
//         setShowRequestModal(false);
//         setRequestMessage('');
//         setRequestDocuments([]);
//         alert('Additional documents requested successfully!');
//         loadApplicationDetails(); // Refresh to show the request
//       } else {
//         alert('Error requesting documents: ' + result.error);
//       }
//     } catch (error) {
//       console.error('Error requesting documents:', error);
//       alert('Failed to request additional documents');
//     } finally {
//       setActionLoading(prev => ({ ...prev, request: false }));
//     }
//   };

//   const openDocument = (document) => {
//     setSelectedDocument(document);
//     setShowDocumentModal(true);
//   };

//   const downloadDocument = (document) => {
//     const link = document.createElement('a');
//     link.href = document.url;
//     link.download = document.fileName;
//     link.click();
//   };

//   const formatDate = (timestamp) => {
//     if (!timestamp) return 'N/A';
//     const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
//     return date.toLocaleDateString('en-IN', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'pending':
//         return 'bg-yellow-100 text-yellow-800 border-yellow-200';
//       case 'approved':
//         return 'bg-green-100 text-green-800 border-green-200';
//       case 'rejected':
//         return 'bg-red-100 text-red-800 border-red-200';
//       default:
//         return 'bg-gray-100 text-gray-800 border-gray-200';
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
//         <div className="text-center">
//           <Loader className="h-8 w-8 animate-spin text-teal-500 mx-auto mb-4" />
//           <p className="text-gray-600">Loading application details...</p>
//         </div>
//       </div>
//     );
//   }

//   if (!application) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
//         <div className="text-center">
//           <TrendingUp className="h-12 w-12 text-gray-400 mx-auto mb-4" />
//           <h3 className="text-lg font-medium text-gray-900 mb-2">Application Not Found</h3>
//           <p className="text-gray-600 mb-4">The requested lead generator application could not be found.</p>
//           <button 
//             onClick={() => navigate('/admin/lead-approvals')}
//             className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 transition-all"
//           >
//             <ArrowLeft className="h-4 w-4 mr-2" />
//             Back to Applications
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between py-4">
//             <div className="flex items-center space-x-4">
//               <button
//                 onClick={() => navigate('/admin/dashboard')}
//                 className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//               >
//                 <ArrowLeft className="h-4 w-4 mr-2" />
//                 Back to Dashboard
//               </button>

//               <div>
//                 <h1 className="text-2xl font-bold text-gray-900">Lead Generator Application Details</h1>
//                 <p className="text-sm text-gray-600">Application ID: {application.applicationId}</p>
//               </div>
//             </div>

//             <div className="flex items-center space-x-3">
//               <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
//                 {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
//               </span>

//               {application.status === 'pending' && (
//                 <div className="flex items-center space-x-2">
//                   <button
//                     onClick={() => setShowRequestModal(true)}
//                     className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//                   >
//                     <MessageSquare className="h-4 w-4 mr-2" />
//                     Request Data
//                   </button>

//                   <button
//                     onClick={() => setShowRejectionModal(true)}
//                     className="inline-flex items-center px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors"
//                   >
//                     <XCircle className="h-4 w-4 mr-2" />
//                     Reject
//                   </button>

//                   <button
//                     onClick={() => setShowApprovalModal(true)}
//                     className="inline-flex items-center px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
//                   >
//                     <CheckCircle className="h-4 w-4 mr-2" />
//                     Approve
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

//           {/* Main Content */}
//           <div className="lg:col-span-2 space-y-6">

//             {/* Basic Information */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-teal-100 p-2 rounded-lg">
//                   <TrendingUp className="h-5 w-5 text-teal-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Basic Information</h2>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div className="space-y-4">
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Entity Name</label>
//                     <p className="text-lg font-semibold text-gray-900">{application.entityName}</p>
//                   </div>

//                   <div>
//                     <label className="text-sm font-medium text-gray-500">CIN Number</label>
//                     <div className="flex items-center space-x-2">
//                       <Hash className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900 font-mono">{application.cinNumber}</p>
//                     </div>
//                   </div>

//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Email Address</label>
//                     <div className="flex items-center space-x-2">
//                       <Mail className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900">{application.email}</p>
//                     </div>
//                   </div>

//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Phone Number</label>
//                     <div className="flex items-center space-x-2">
//                       <Phone className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900">{application.phone}</p>
//                     </div>
//                   </div>

//                   {application.website && (
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Website</label>
//                       <div className="flex items-center space-x-2">
//                         <Globe className="h-4 w-4 text-gray-400" />
//                         <a 
//                           href={application.website} 
//                           target="_blank" 
//                           rel="noopener noreferrer"
//                           className="text-teal-600 hover:text-teal-800"
//                         >
//                           {application.website}
//                           <ExternalLink className="h-3 w-3 ml-1 inline" />
//                         </a>
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div className="space-y-4">
//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Address</label>
//                     <div className="flex items-start space-x-2">
//                       <MapPin className="h-4 w-4 text-gray-400 mt-1" />
//                       <div>
//                         <p className="text-gray-900">{application.address}</p>
//                         <p className="text-gray-600">{application.city}, {application.state}</p>
//                         <p className="text-gray-600">{application.pincode}</p>
//                       </div>
//                     </div>
//                   </div>

//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Application Submitted</label>
//                     <div className="flex items-center space-x-2">
//                       <Calendar className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900">{formatDate(application.submittedAt)}</p>
//                     </div>
//                   </div>

//                   <div>
//                     <label className="text-sm font-medium text-gray-500">Official Email</label>
//                     <div className="flex items-center space-x-2">
//                       <Mail className="h-4 w-4 text-gray-400" />
//                       <p className="text-gray-900">{application.officialEmail}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Services Required */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-blue-100 p-2 rounded-lg">
//                   <Briefcase className="h-5 w-5 text-blue-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Services Required</h2>
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
//                 <div className="bg-gray-50 rounded-lg p-4">
//                   <div className="flex items-center space-x-2 mb-2">
//                     <Activity className="h-5 w-5 text-gray-600" />
//                     <span className="text-sm font-medium text-gray-500">Total Services</span>
//                   </div>
//                   <p className="text-2xl font-bold text-gray-900">{application.servicesRequired?.length || 0}</p>
//                 </div>

//                 <div className="bg-gray-50 rounded-lg p-4">
//                   <div className="flex items-center space-x-2 mb-2">
//                     <CheckSquare className="h-5 w-5 text-gray-600" />
//                     <span className="text-sm font-medium text-gray-500">Service Category</span>
//                   </div>
//                   <p className="text-lg font-bold text-gray-900">Healthcare</p>
//                 </div>

//                 <div className="bg-gray-50 rounded-lg p-4">
//                   <div className="flex items-center space-x-2 mb-2">
//                     <Star className="h-5 w-5 text-gray-600" />
//                     <span className="text-sm font-medium text-gray-500">Priority Level</span>
//                   </div>
//                   <p className="text-lg font-bold text-gray-900">Standard</p>
//                 </div>
//               </div>

//               {/* Services List */}
//               {application.servicesRequired && application.servicesRequired.length > 0 && (
//                 <div className="mt-6">
//                   <h3 className="text-lg font-medium text-gray-900 mb-3">Selected Services</h3>
//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                     {application.servicesRequired.map((service, index) => (
//                       <div key={index} className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
//                         <CheckCircle className="h-4 w-4 text-blue-600" />
//                         <span className="text-sm font-medium text-gray-700">{service}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Representative Information */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-purple-100 p-2 rounded-lg">
//                   <Users className="h-5 w-5 text-purple-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Representative Information</h2>
//               </div>

//               <div className="border border-gray-200 rounded-lg p-4">
//                 <h3 className="text-lg font-medium text-gray-900 mb-4">Entity Representative</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div className="space-y-3">
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Name</label>
//                       <p className="text-gray-900">{application.representative?.name}</p>
//                     </div>
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Contact Number</label>
//                       <p className="text-gray-900">{application.representative?.contact}</p>
//                     </div>
//                   </div>
//                   <div className="space-y-3">
//                     <div>
//                       <label className="text-sm font-medium text-gray-500">Email Address</label>
//                       <p className="text-gray-900">{application.representative?.email}</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Documents */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <div className="flex items-center space-x-3 mb-6">
//                 <div className="bg-orange-100 p-2 rounded-lg">
//                   <FileText className="h-5 w-5 text-orange-600" />
//                 </div>
//                 <h2 className="text-xl font-semibold text-gray-900">Uploaded Documents</h2>
//               </div>

//               {application.documents ? (
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   {Object.entries(application.documents).map(([key, doc]) => (
//                     <div key={key} className="border border-gray-200 rounded-lg p-4">
//                       <div className="flex items-center justify-between mb-2">
//                         <h4 className="font-medium text-gray-900">
//                           {key === 'kycDocuments' ? 'KYC Documents' : 
//                            key === 'mouDocument' ? 'MOU Document' :
//                            key === 'entityLogo' ? 'Entity Logo' :
//                            key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
//                         </h4>
//                         <div className="flex items-center space-x-2">
//                           <button
//                             onClick={() => openDocument(doc)}
//                             className="text-blue-600 hover:text-blue-800"
//                             title="View Document"
//                           >
//                             <Eye className="h-4 w-4" />
//                           </button>
//                           <button
//                             onClick={() => downloadDocument(doc)}
//                             className="text-green-600 hover:text-green-800"
//                             title="Download Document"
//                           >
//                             <Download className="h-4 w-4" />
//                           </button>
//                         </div>
//                       </div>
//                       <p className="text-sm text-gray-600">{doc.fileName}</p>
//                       <p className="text-xs text-gray-500">Size: {(doc.size / 1024).toFixed(1)} KB</p>
//                       <p className="text-xs text-gray-500">Uploaded: {formatDate(doc.uploadedAt)}</p>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <p className="text-gray-500">No documents uploaded</p>
//               )}
//             </div>
//           </div>

//           {/* Sidebar */}
//           <div className="space-y-6">

//             {/* Application Status */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <h3 className="text-lg font-semibold text-gray-900 mb-4">Application Status</h3>

//               <div className="space-y-4">
//                 <div className="flex items-center justify-between">
//                   <span className="text-sm font-medium text-gray-500">Current Status</span>
//                   <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(application.status)}`}>
//                     {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
//                   </span>
//                 </div>

//                 <div className="flex items-center justify-between">
//                   <span className="text-sm font-medium text-gray-500">Submitted On</span>
//                   <span className="text-sm text-gray-900">{formatDate(application.submittedAt)}</span>
//                 </div>

//                 {application.approvedAt && (
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-gray-500">Approved On</span>
//                     <span className="text-sm text-gray-900">{formatDate(application.approvedAt)}</span>
//                   </div>
//                 )}

//                 {application.rejectedAt && (
//                   <div className="flex items-center justify-between">
//                     <span className="text-sm font-medium text-gray-500">Rejected On</span>
//                     <span className="text-sm text-gray-900">{formatDate(application.rejectedAt)}</span>
//                   </div>
//                 )}
//               </div>

//               {application.rejectionReason && (
//                 <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
//                   <h4 className="text-sm font-medium text-red-800 mb-1">Rejection Reason</h4>
//                   <p className="text-sm text-red-700">{application.rejectionReason}</p>
//                 </div>
//               )}
//             </div>

//             {/* Quick Actions */}
//             {application.status === 'pending' && (
//               <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//                 <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>

//                 <div className="space-y-3">
//                   <button
//                     onClick={() => setShowRequestModal(true)}
//                     className="w-full inline-flex items-center justify-start px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//                   >
//                     <MessageSquare className="h-4 w-4 mr-2" />
//                     Request Additional Data
//                   </button>

//                   <button
//                     onClick={() => setShowRejectionModal(true)}
//                     className="w-full inline-flex items-center justify-start px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors"
//                   >
//                     <XCircle className="h-4 w-4 mr-2" />
//                     Reject Application
//                   </button>

//                   <button
//                     onClick={() => setShowApprovalModal(true)}
//                     className="w-full inline-flex items-center justify-start px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
//                   >
//                     <CheckCircle className="h-4 w-4 mr-2" />
//                     Approve Application
//                   </button>
//                 </div>
//               </div>
//             )}

//             {/* Activity Timeline */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
//               <h3 className="text-lg font-semibold text-gray-900 mb-4">Activity Timeline</h3>

//               <div className="space-y-4">
//                 <div className="flex items-start space-x-3">
//                   <div className="bg-blue-100 p-1 rounded-full">
//                     <Clock className="h-3 w-3 text-blue-600" />
//                   </div>
//                   <div>
//                     <p className="text-sm font-medium text-gray-900">Application Submitted</p>
//                     <p className="text-xs text-gray-500">{formatDate(application.submittedAt)}</p>
//                   </div>
//                 </div>

//                 {application.status === 'approved' && (
//                   <div className="flex items-start space-x-3">
//                     <div className="bg-green-100 p-1 rounded-full">
//                       <CheckCircle className="h-3 w-3 text-green-600" />
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-900">Application Approved</p>
//                       <p className="text-xs text-gray-500">{formatDate(application.approvedAt)}</p>
//                     </div>
//                   </div>
//                 )}

//                 {application.status === 'rejected' && (
//                   <div className="flex items-start space-x-3">
//                     <div className="bg-red-100 p-1 rounded-full">
//                       <XCircle className="h-3 w-3 text-red-600" />
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium text-gray-900">Application Rejected</p>
//                       <p className="text-xs text-gray-500">{formatDate(application.rejectedAt)}</p>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Document Viewer Modal */}
//       {showDocumentModal && selectedDocument && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
//             <div className="flex items-center justify-between p-4 border-b border-gray-200">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
//                 <p className="text-sm text-gray-600">{selectedDocument.fileName}</p>
//               </div>
//               <div className="flex items-center space-x-2">
//                 <button
//                   onClick={() => downloadDocument(selectedDocument)}
//                   className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//                 >
//                   <Download className="h-4 w-4 mr-2" />
//                   Download
//                 </button>
//                 <button
//                   onClick={() => setShowDocumentModal(false)}
//                   className="text-gray-400 hover:text-gray-600"
//                 >
//                   <X className="h-6 w-6" />
//                 </button>
//               </div>
//             </div>

//             <div className="flex-1 p-4">
//               {selectedDocument.fileName.toLowerCase().endsWith('.pdf') ? (
//                 <iframe
//                   src={selectedDocument.url}
//                   className="w-full h-full border border-gray-300 rounded"
//                   title="Document Viewer"
//                 />
//               ) : (
//                 <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded">
//                   <img
//                     src={selectedDocument.url}
//                     alt={selectedDocument.fileName}
//                     className="max-w-full max-h-full object-contain"
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Approval Modal */}
//       {showApprovalModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-md w-full p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">Approve Lead Generator Application</h3>
//               <button
//                 onClick={() => setShowApprovalModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="mb-6">
//               <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
//                 <div className="flex items-center space-x-3">
//                   <CheckCircle className="h-5 w-5 text-green-600" />
//                   <div>
//                     <h4 className="font-medium text-green-800">Approving Lead Generator</h4>
//                     <p className="text-sm text-green-600">
//                       {application.entityName} will be granted access to the selected services
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Account Password *
//                 </label>
//                 <input
//                   type="password"
//                   value={approvalPassword}
//                   onChange={(e) => setApprovalPassword(e.target.value)}
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                   placeholder="Enter password for lead generator account"
//                   required
//                 />
//                 <p className="text-xs text-gray-500 mt-1">
//                   This password will be sent to the lead generator for account access
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowApprovalModal(false)}
//                 className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleApproveLeadGenerator}
//                 disabled={!approvalPassword.trim() || actionLoading.approve}
//                 className="inline-flex items-center px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//               >
//                 {actionLoading.approve ? (
//                   <>
//                     <Loader className="h-4 w-4 mr-2 animate-spin" />
//                     Approving...
//                   </>
//                 ) : (
//                   <>
//                     <CheckCircle className="h-4 w-4 mr-2" />
//                     Approve Lead Generator
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Rejection Modal */}
//       {showRejectionModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-md w-full p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">Reject Lead Generator Application</h3>
//               <button
//                 onClick={() => setShowRejectionModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="mb-6">
//               <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
//                 <div className="flex items-center space-x-3">
//                   <XCircle className="h-5 w-5 text-red-600" />
//                   <div>
//                     <h4 className="font-medium text-red-800">Rejecting Application</h4>
//                     <p className="text-sm text-red-600">
//                       {application.entityName} will be notified about the rejection
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Rejection Reason *
//                 </label>
//                 <textarea
//                   value={rejectionReason}
//                   onChange={(e) => setRejectionReason(e.target.value)}
//                   rows="4"
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                   placeholder="Provide detailed reason for rejection..."
//                   required
//                 />
//                 <p className="text-xs text-gray-500 mt-1">
//                   This reason will be communicated to the lead generator
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowRejectionModal(false)}
//                 className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleRejectLeadGenerator}
//                 disabled={!rejectionReason.trim() || actionLoading.reject}
//                 className="inline-flex items-center px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//               >
//                 {actionLoading.reject ? (
//                   <>
//                     <Loader className="h-4 w-4 mr-2 animate-spin" />
//                     Rejecting...
//                   </>
//                 ) : (
//                   <>
//                     <XCircle className="h-4 w-4 mr-2" />
//                     Reject Application
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Request Additional Data Modal */}
//       {showRequestModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg max-w-lg w-full p-6">
//             <div className="flex items-center justify-between mb-4">
//               <h3 className="text-lg font-semibold text-gray-900">Request Additional Documents</h3>
//               <button
//                 onClick={() => setShowRequestModal(false)}
//                 className="text-gray-400 hover:text-gray-600"
//               >
//                 <X className="h-6 w-6" />
//               </button>
//             </div>

//             <div className="mb-6">
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
//                 <div className="flex items-center space-x-3">
//                   <MessageSquare className="h-5 w-5 text-blue-600" />
//                   <div>
//                     <h4 className="font-medium text-blue-800">Request from Lead Generator</h4>
//                     <p className="text-sm text-blue-600">
//                       {application.entityName} will be notified to submit additional documents
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Request Message *
//                 </label>
//                 <textarea
//                   value={requestMessage}
//                   onChange={(e) => setRequestMessage(e.target.value)}
//                   rows="3"
//                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
//                   placeholder="Explain what additional information or documents are needed..."
//                   required
//                 />
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Required Documents *
//                 </label>
//                 <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3">
//                   {availableDocuments.map((doc, index) => (
//                     <label key={index} className="flex items-center space-x-2">
//                       <input
//                         type="checkbox"
//                         checked={requestDocuments.includes(doc)}
//                         onChange={(e) => {
//                           if (e.target.checked) {
//                             setRequestDocuments([...requestDocuments, doc]);
//                           } else {
//                             setRequestDocuments(requestDocuments.filter(d => d !== doc));
//                           }
//                         }}
//                         className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
//                       />
//                       <span className="text-sm text-gray-700">{doc}</span>
//                     </label>
//                   ))}
//                 </div>
//                 <p className="text-xs text-gray-500 mt-1">
//                   Select the documents that need to be submitted
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowRequestModal(false)}
//                 className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleRequestAdditionalData}
//                 disabled={!requestMessage.trim() || requestDocuments.length === 0 || actionLoading.request}
//                 className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
//               >
//                 {actionLoading.request ? (
//                   <>
//                     <Loader className="h-4 w-4 mr-2 animate-spin" />
//                     Sending Request...
//                   </>
//                 ) : (
//                   <>
//                     <Send className="h-4 w-4 mr-2" />
//                     Send Request
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default LeadGeneratorApplicationDetails;
// File Location: src/pages/admin/LeadGeneratorApplicationDetails.jsx

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useBackToDashboard } from '../../utils/navigationUtils';
import {
  ArrowLeft,
  TrendingUp,
  MapPin,
  Phone,
  Mail,
  Calendar,
  User,
  FileText,
  Download,
  Eye,
  X,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Loader,
  Send,
  MessageSquare,
  Clock,
  Shield,
  Users,
  Activity,
  CreditCard,
  Globe,
  Building2,
  Briefcase,
  CheckSquare,
  Star,
  ExternalLink,
  Hash,
  Building,
  Edit3,
  Save,
  Ban,
  Unlock
} from 'lucide-react';
import {
  getLeadGeneratorApplication,
  approveLeadGeneratorApplication,
  rejectLeadGeneratorApplication,
  requestAdditionalDocuments,
  updateLeadGeneratorServices,
  blockLeadGenerator,
  unblockLeadGenerator
} from '../../services/leadGeneratorService';
import { useAuth } from '../../context/AuthContext';

const LeadGeneratorApplicationDetails = () => {
  const { applicationId } = useParams();
  const navigate = useNavigate();
  const { userData } = useAuth();
  const goBackToDashboard = useBackToDashboard();

  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({});
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showServicesModal, setShowServicesModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);

  // Form states
  const [approvalPassword, setApprovalPassword] = useState('');
  const [rejectionReason, setRejectionReason] = useState('');
  const [requestMessage, setRequestMessage] = useState('');
  const [requestDocuments, setRequestDocuments] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [blockReason, setBlockReason] = useState('');

  // Available document types for requests
  const availableDocuments = [
    'Updated CIN Certificate',
    'Latest KYC Documents',
    'MOU Agreement Updates',
    'Business Registration Certificate',
    'Tax Registration Documents',
    'GST Certificate',
    'Additional Bank Documents',
    'Entity Logo (High Resolution)',
    'Service Agreement Documents',
    'Compliance Certificates'
  ];

  useEffect(() => {
    loadApplicationDetails();
  }, [applicationId]);

  useEffect(() => {
    if (application) {
      setSelectedServices(application.approvedServices || application.servicesRequired || []);
    }
  }, [application]);

  const loadApplicationDetails = async () => {
    setLoading(true);
    try {
      const result = await getLeadGeneratorApplication(applicationId);
      if (result.success) {
        setApplication(result.application);
      } else {
        console.error('Error loading application:', result.error);
      }
    } catch (error) {
      console.error('Error loading application details:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleApproveLeadGenerator = async () => {
    if (!approvalPassword.trim() || selectedServices.length === 0) return;

    setActionLoading(prev => ({ ...prev, approve: true }));
    try {
      const result = await approveLeadGeneratorApplication(
        applicationId,
        userData.uid,
        approvalPassword,
        selectedServices
      );

      if (result.success) {
        setApplication(prev => ({
          ...prev,
          status: 'approved',
          approvedBy: userData.uid,
          approvedAt: new Date(),
          approvedServices: selectedServices
        }));
        setShowApprovalModal(false);
        setApprovalPassword('');
        alert('Lead Generator approved successfully!');
      } else {
        alert('Error approving lead generator: ' + result.error);
      }
    } catch (error) {
      console.error('Error approving lead generator:', error);
      alert('Failed to approve lead generator');
    } finally {
      setActionLoading(prev => ({ ...prev, approve: false }));
    }
  };

  const handleUpdateServices = async () => {
    if (selectedServices.length === 0) return;

    setActionLoading(prev => ({ ...prev, updateServices: true }));
    try {
      const result = await updateLeadGeneratorServices(
        application.id,
        userData.uid,
        selectedServices
      );

      if (result.success) {
        setApplication(prev => ({
          ...prev,
          approvedServices: selectedServices,
          updatedAt: new Date()
        }));
        setShowServicesModal(false);
        alert('Services updated successfully!');
      } else {
        alert('Error updating services: ' + result.error);
      }
    } catch (error) {
      console.error('Error updating services:', error);
      alert('Failed to update services');
    } finally {
      setActionLoading(prev => ({ ...prev, updateServices: false }));
    }
  };

  const handleBlockUnblockAccount = async () => {
    const isBlocking = !application.isBlocked;

    if (isBlocking && !blockReason.trim()) return;

    setActionLoading(prev => ({ ...prev, blockAccount: true }));
    try {
      const result = isBlocking
        ? await blockLeadGenerator(application.id, userData.uid, blockReason)
        : await unblockLeadGenerator(application.id, userData.uid);

      if (result.success) {
        setApplication(prev => ({
          ...prev,
          isBlocked: isBlocking,
          blockedBy: isBlocking ? userData.uid : null,
          blockedAt: isBlocking ? new Date() : null,
          blockReason: isBlocking ? blockReason : null,
          unblockedAt: isBlocking ? null : new Date()
        }));
        setShowBlockModal(false);
        setBlockReason('');
        alert(`Account ${isBlocking ? 'blocked' : 'unblocked'} successfully!`);
      } else {
        alert(`Error ${isBlocking ? 'blocking' : 'unblocking'} account: ` + result.error);
      }
    } catch (error) {
      console.error(`Error ${isBlocking ? 'blocking' : 'unblocking'} account:`, error);
      alert(`Failed to ${isBlocking ? 'block' : 'unblock'} account`);
    } finally {
      setActionLoading(prev => ({ ...prev, blockAccount: false }));
    }
  };

  const handleRejectLeadGenerator = async () => {
    if (!rejectionReason.trim()) return;

    setActionLoading(prev => ({ ...prev, reject: true }));
    try {
      const result = await rejectLeadGeneratorApplication(
        applicationId,
        userData.uid,
        rejectionReason
      );

      if (result.success) {
        setApplication(prev => ({
          ...prev,
          status: 'rejected',
          rejectedBy: userData.uid,
          rejectedAt: new Date(),
          rejectionReason
        }));
        setShowRejectionModal(false);
        setRejectionReason('');
        alert('Lead Generator application rejected.');
      } else {
        alert('Error rejecting lead generator: ' + result.error);
      }
    } catch (error) {
      console.error('Error rejecting lead generator:', error);
      alert('Failed to reject lead generator');
    } finally {
      setActionLoading(prev => ({ ...prev, reject: false }));
    }
  };

  const handleRequestAdditionalData = async () => {
    if (!requestMessage.trim() || requestDocuments.length === 0) return;

    setActionLoading(prev => ({ ...prev, request: true }));
    try {
      const result = await requestAdditionalDocuments(
        applicationId,
        userData.uid,
        requestMessage,
        requestDocuments
      );

      if (result.success) {
        setShowRequestModal(false);
        setRequestMessage('');
        setRequestDocuments([]);
        alert('Additional documents requested successfully!');
        loadApplicationDetails(); // Refresh to show the request
      } else {
        alert('Error requesting documents: ' + result.error);
      }
    } catch (error) {
      console.error('Error requesting documents:', error);
      alert('Failed to request additional documents');
    } finally {
      setActionLoading(prev => ({ ...prev, request: false }));
    }
  };

  const openDocument = (document) => {
    setSelectedDocument(document);
    setShowDocumentModal(true);
  };

  const downloadDocument = (document) => {
    const link = document.createElement('a');
    link.href = document.url;
    link.download = document.fileName;
    link.click();
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'approved':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <Loader className="h-8 w-8 animate-spin text-teal-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading application details...</p>
        </div>
      </div>
    );
  }

  if (!application) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <TrendingUp className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">Application Not Found</h3>
          <p className="text-gray-600 mb-4">The requested lead generator application could not be found.</p>
          <button
            onClick={() => navigate('/admin/lead-approvals')}
            className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 transition-all"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Applications
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => goBackToDashboard(navigate)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Dashboard
              </button>

              <div>
                <h1 className="text-2xl font-bold text-gray-900">Lead Generator Application Details</h1>
                <p className="text-sm text-gray-600">Application ID: {application.applicationId}</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <span className={`px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(application.status)}`}>
                {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
              </span>

              {application.isBlocked && (
                <span className="px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800 border border-red-200">
                  Blocked
                </span>
              )}

              {application.status === 'pending' && (
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => setShowRequestModal(true)}
                    className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <MessageSquare className="h-4 w-4 mr-2" />
                    Request Data
                  </button>

                  <button
                    onClick={() => setShowRejectionModal(true)}
                    className="inline-flex items-center px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors"
                  >
                    <XCircle className="h-4 w-4 mr-2" />
                    Reject
                  </button>

                  <button
                    onClick={() => setShowApprovalModal(true)}
                    className="inline-flex items-center px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
                  >
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Approve
                  </button>
                </div>
              )}

              {application.status === 'approved' && (
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => setShowServicesModal(true)}
                    className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <Edit3 className="h-4 w-4 mr-2" />
                    Edit Services
                  </button>

                  <button
                    onClick={() => setShowBlockModal(true)}
                    className={`inline-flex items-center px-4 py-2 font-medium rounded-lg transition-colors ${application.isBlocked
                        ? 'bg-green-600 text-white hover:bg-green-700'
                        : 'bg-red-600 text-white hover:bg-red-700'
                      }`}
                  >
                    {application.isBlocked ? (
                      <>
                        <Unlock className="h-4 w-4 mr-2" />
                        Unblock Account
                      </>
                    ) : (
                      <>
                        <Ban className="h-4 w-4 mr-2" />
                        Block Account
                      </>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6">

            {/* Basic Information */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-teal-100 p-2 rounded-lg">
                  <TrendingUp className="h-5 w-5 text-teal-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900">Basic Information</h2>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-medium text-gray-500">Entity Name</label>
                    <p className="text-lg font-semibold text-gray-900">{application.entityName}</p>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-500">CIN Number</label>
                    <div className="flex items-center space-x-2">
                      <Hash className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900 font-mono">{application.cinNumber}</p>
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-500">Email Address</label>
                    <div className="flex items-center space-x-2">
                      <Mail className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{application.email}</p>
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-500">Phone Number</label>
                    <div className="flex items-center space-x-2">
                      <Phone className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{application.phone}</p>
                    </div>
                  </div>

                  {application.website && (
                    <div>
                      <label className="text-sm font-medium text-gray-500">Website</label>
                      <div className="flex items-center space-x-2">
                        <Globe className="h-4 w-4 text-gray-400" />
                        <a
                          href={application.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-teal-600 hover:text-teal-800"
                        >
                          {application.website}
                          <ExternalLink className="h-3 w-3 ml-1 inline" />
                        </a>
                      </div>
                    </div>
                  )}
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="text-sm font-medium text-gray-500">Address</label>
                    <div className="flex items-start space-x-2">
                      <MapPin className="h-4 w-4 text-gray-400 mt-1" />
                      <div>
                        <p className="text-gray-900">{application.address}</p>
                        <p className="text-gray-600">{application.city}, {application.state}</p>
                        <p className="text-gray-600">{application.pincode}</p>
                      </div>
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-500">Application Submitted</label>
                    <div className="flex items-center space-x-2">
                      <Calendar className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{formatDate(application.submittedAt)}</p>
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-500">Official Email</label>
                    <div className="flex items-center space-x-2">
                      <Mail className="h-4 w-4 text-gray-400" />
                      <p className="text-gray-900">{application.officialEmail}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Services Required/Approved */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center space-x-3">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <Briefcase className="h-5 w-5 text-blue-600" />
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900">
                    {application.status === 'approved' ? 'Approved Services' : 'Services Required'}
                  </h2>
                </div>

                {application.status === 'approved' && (
                  <button
                    onClick={() => setShowServicesModal(true)}
                    className="inline-flex items-center px-3 py-1 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <Edit3 className="h-3 w-3 mr-1" />
                    Edit
                  </button>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Activity className="h-5 w-5 text-gray-600" />
                    <span className="text-sm font-medium text-gray-500">Requested Services</span>
                  </div>
                  <p className="text-2xl font-bold text-gray-900">{application.servicesRequired?.length || 0}</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <CheckSquare className="h-5 w-5 text-gray-600" />
                    <span className="text-sm font-medium text-gray-500">Approved Services</span>
                  </div>
                  <p className="text-2xl font-bold text-green-600">{application.approvedServices?.length || 0}</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Star className="h-5 w-5 text-gray-600" />
                    <span className="text-sm font-medium text-gray-500">Service Category</span>
                  </div>
                  <p className="text-lg font-bold text-gray-900">Healthcare</p>
                </div>
              </div>

              {/* Requested Services */}
              {application.servicesRequired && application.servicesRequired.length > 0 && (
                <div className="mb-6">
                  <h3 className="text-lg font-medium text-gray-900 mb-3">Requested Services</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {application.servicesRequired.map((service, index) => (
                      <div key={index} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <CheckCircle className="h-4 w-4 text-gray-600" />
                        <span className="text-sm font-medium text-gray-700">{service}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Approved Services */}
              {application.approvedServices && application.approvedServices.length > 0 && (
                <div>
                  <h3 className="text-lg font-medium text-gray-900 mb-3">Approved Services</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {application.approvedServices.map((service, index) => (
                      <div key={index} className="flex items-center space-x-3 p-3 bg-green-50 rounded-lg border border-green-200">
                        <CheckCircle className="h-4 w-4 text-green-600" />
                        <span className="text-sm font-medium text-gray-700">{service}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Representative Information */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-purple-100 p-2 rounded-lg">
                  <Users className="h-5 w-5 text-purple-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900">Representative Information</h2>
              </div>

              <div className="border border-gray-200 rounded-lg p-4">
                <h3 className="text-lg font-medium text-gray-900 mb-4">Entity Representative</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-3">
                    <div>
                      <label className="text-sm font-medium text-gray-500">Name</label>
                      <p className="text-gray-900">{application.representative?.name}</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-gray-500">Contact Number</label>
                      <p className="text-gray-900">{application.representative?.contact}</p>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div>
                      <label className="text-sm font-medium text-gray-500">Email Address</label>
                      <p className="text-gray-900">{application.representative?.email}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Documents */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="bg-orange-100 p-2 rounded-lg">
                  <FileText className="h-5 w-5 text-orange-600" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900">Uploaded Documents</h2>
              </div>

              {application.documents ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {Object.entries(application.documents).map(([key, doc]) => (
                    <div key={key} className="border border-gray-200 rounded-lg p-4">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="font-medium text-gray-900">
                          {key === 'kycDocuments' ? 'KYC Documents' :
                            key === 'mouDocument' ? 'MOU Document' :
                              key === 'entityLogo' ? 'Entity Logo' :
                                key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                        </h4>
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => openDocument(doc)}
                            className="text-blue-600 hover:text-blue-800"
                            title="View Document"
                          >
                            <Eye className="h-4 w-4" />
                          </button>
                          <button
                            onClick={() => downloadDocument(doc)}
                            className="text-green-600 hover:text-green-800"
                            title="Download Document"
                          >
                            <Download className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                      <p className="text-sm text-gray-600">{doc.fileName}</p>
                      <p className="text-xs text-gray-500">Size: {(doc.size / 1024).toFixed(1)} KB</p>
                      <p className="text-xs text-gray-500">Uploaded: {formatDate(doc.uploadedAt)}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500">No documents uploaded</p>
              )}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">

            {/* Application Status */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Application Status</h3>

              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-500">Current Status</span>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(application.status)}`}>
                    {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-500">Submitted On</span>
                  <span className="text-sm text-gray-900">{formatDate(application.submittedAt)}</span>
                </div>

                {application.approvedAt && (
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-500">Approved On</span>
                    <span className="text-sm text-gray-900">{formatDate(application.approvedAt)}</span>
                  </div>
                )}

                {application.rejectedAt && (
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-500">Rejected On</span>
                    <span className="text-sm text-gray-900">{formatDate(application.rejectedAt)}</span>
                  </div>
                )}

                {application.isBlocked && (
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-500">Account Status</span>
                    <span className="text-sm font-medium text-red-600">Blocked</span>
                  </div>
                )}
              </div>

              {application.rejectionReason && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <h4 className="text-sm font-medium text-red-800 mb-1">Rejection Reason</h4>
                  <p className="text-sm text-red-700">{application.rejectionReason}</p>
                </div>
              )}

              {application.blockReason && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                  <h4 className="text-sm font-medium text-red-800 mb-1">Block Reason</h4>
                  <p className="text-sm text-red-700">{application.blockReason}</p>
                </div>
              )}
            </div>

            {/* Quick Actions */}
            {application.status === 'pending' && (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>

                <div className="space-y-3">
                  <button
                    onClick={() => setShowRequestModal(true)}
                    className="w-full inline-flex items-center justify-start px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <MessageSquare className="h-4 w-4 mr-2" />
                    Request Additional Data
                  </button>

                  <button
                    onClick={() => setShowRejectionModal(true)}
                    className="w-full inline-flex items-center justify-start px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors"
                  >
                    <XCircle className="h-4 w-4 mr-2" />
                    Reject Application
                  </button>

                  <button
                    onClick={() => setShowApprovalModal(true)}
                    className="w-full inline-flex items-center justify-start px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
                  >
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Approve Application
                  </button>
                </div>
              </div>
            )}

            {/* Approved Actions */}
            {application.status === 'approved' && (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Account Management</h3>

                <div className="space-y-3">
                  <button
                    onClick={() => setShowServicesModal(true)}
                    className="w-full inline-flex items-center justify-start px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <Edit3 className="h-4 w-4 mr-2" />
                    Edit Service Eligibility
                  </button>

                  <button
                    onClick={() => setShowBlockModal(true)}
                    className={`w-full inline-flex items-center justify-start px-4 py-2 font-medium rounded-lg transition-colors ${application.isBlocked
                        ? 'bg-green-600 text-white hover:bg-green-700'
                        : 'bg-red-600 text-white hover:bg-red-700'
                      }`}
                  >
                    {application.isBlocked ? (
                      <>
                        <Unlock className="h-4 w-4 mr-2" />
                        Unblock Account
                      </>
                    ) : (
                      <>
                        <Ban className="h-4 w-4 mr-2" />
                        Block Account
                      </>
                    )}
                  </button>
                </div>
              </div>
            )}

            {/* Activity Timeline */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Activity Timeline</h3>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="bg-blue-100 p-1 rounded-full">
                    <Clock className="h-3 w-3 text-blue-600" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">Application Submitted</p>
                    <p className="text-xs text-gray-500">{formatDate(application.submittedAt)}</p>
                  </div>
                </div>

                {application.status === 'approved' && (
                  <div className="flex items-start space-x-3">
                    <div className="bg-green-100 p-1 rounded-full">
                      <CheckCircle className="h-3 w-3 text-green-600" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">Application Approved</p>
                      <p className="text-xs text-gray-500">{formatDate(application.approvedAt)}</p>
                    </div>
                  </div>
                )}

                {application.status === 'rejected' && (
                  <div className="flex items-start space-x-3">
                    <div className="bg-red-100 p-1 rounded-full">
                      <XCircle className="h-3 w-3 text-red-600" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">Application Rejected</p>
                      <p className="text-xs text-gray-500">{formatDate(application.rejectedAt)}</p>
                    </div>
                  </div>
                )}

                {application.isBlocked && (
                  <div className="flex items-start space-x-3">
                    <div className="bg-red-100 p-1 rounded-full">
                      <Ban className="h-3 w-3 text-red-600" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-900">Account Blocked</p>
                      <p className="text-xs text-gray-500">{formatDate(application.blockedAt)}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Document Viewer Modal */}
      {showDocumentModal && selectedDocument && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-4xl w-full h-5/6 flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Document Viewer</h3>
                <p className="text-sm text-gray-600">{selectedDocument.fileName}</p>
              </div>
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => downloadDocument(selectedDocument)}
                  className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
                >
                  <Download className="h-4 w-4 mr-2" />
                  Download
                </button>
                <button
                  onClick={() => setShowDocumentModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="flex-1 p-4">
              {selectedDocument.fileName.toLowerCase().endsWith('.pdf') ? (
                <iframe
                  src={selectedDocument.url}
                  className="w-full h-full border border-gray-300 rounded"
                  title="Document Viewer"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded">
                  <img
                    src={selectedDocument.url}
                    alt={selectedDocument.fileName}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Approval Modal with Service Selection */}
      {showApprovalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Approve Lead Generator Application</h3>
              <button
                onClick={() => setShowApprovalModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
                <div className="flex items-center space-x-3">
                  <CheckCircle className="h-5 w-5 text-green-600" />
                  <div>
                    <h4 className="font-medium text-green-800">Approving Lead Generator</h4>
                    <p className="text-sm text-green-600">
                      {application.entityName} will be granted access to the selected services
                    </p>
                  </div>
                </div>
              </div>

              {/* Service Selection */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Select Services to Approve *
                </label>
                <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3">
                  {application.servicesRequired && application.servicesRequired.map((service, index) => (
                    <label key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedServices.includes(service)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedServices([...selectedServices, service]);
                          } else {
                            setSelectedServices(selectedServices.filter(s => s !== service));
                          }
                        }}
                        className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                      />
                      <span className="text-sm text-gray-700">{service}</span>
                    </label>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Select which services to approve for this lead generator
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Account Password *
                </label>
                <input
                  type="password"
                  value={approvalPassword}
                  onChange={(e) => setApprovalPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  placeholder="Enter password for lead generator account"
                  required
                />
                <p className="text-xs text-gray-500 mt-1">
                  This password will be sent to the lead generator for account access
                </p>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowApprovalModal(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleApproveLeadGenerator}
                disabled={!approvalPassword.trim() || selectedServices.length === 0 || actionLoading.approve}
                className="inline-flex items-center px-4 py-2 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {actionLoading.approve ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Approving...
                  </>
                ) : (
                  <>
                    <CheckCircle className="h-4 w-4 mr-2" />
                    Approve with Selected Services
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Services Management Modal */}
      {showServicesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Edit Service Eligibility</h3>
              <button
                onClick={() => setShowServicesModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <div className="flex items-center space-x-3">
                  <Edit3 className="h-5 w-5 text-blue-600" />
                  <div>
                    <h4 className="font-medium text-blue-800">Update Services</h4>
                    <p className="text-sm text-blue-600">
                      Modify which services {application.entityName} can access
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Available Services
                </label>
                <div className="space-y-2 max-h-60 overflow-y-auto border border-gray-200 rounded-lg p-3">
                  {application.servicesRequired && application.servicesRequired.map((service, index) => (
                    <label key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={selectedServices.includes(service)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedServices([...selectedServices, service]);
                          } else {
                            setSelectedServices(selectedServices.filter(s => s !== service));
                          }
                        }}
                        className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                      />
                      <span className="text-sm text-gray-700">{service}</span>
                      {application.approvedServices?.includes(service) && (
                        <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                          Currently Approved
                        </span>
                      )}
                    </label>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Select which services this lead generator should have access to
                </p>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowServicesModal(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateServices}
                disabled={selectedServices.length === 0 || actionLoading.updateServices}
                className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                {actionLoading.updateServices ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Updating...
                  </>
                ) : (
                  <>
                    <Save className="h-4 w-4 mr-2" />
                    Update Services
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Block/Unblock Account Modal */}
      {showBlockModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                {application.isBlocked ? 'Unblock Account' : 'Block Account'}
              </h3>
              <button
                onClick={() => setShowBlockModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className={`border rounded-lg p-4 mb-4 ${application.isBlocked
                  ? 'bg-green-50 border-green-200'
                  : 'bg-red-50 border-red-200'
                }`}>
                <div className="flex items-center space-x-3">
                  {application.isBlocked ? (
                    <Unlock className="h-5 w-5 text-green-600" />
                  ) : (
                    <Ban className="h-5 w-5 text-red-600" />
                  )}
                  <div>
                    <h4 className={`font-medium ${application.isBlocked ? 'text-green-800' : 'text-red-800'
                      }`}>
                      {application.isBlocked ? 'Unblock Lead Generator' : 'Block Lead Generator'}
                    </h4>
                    <p className={`text-sm ${application.isBlocked ? 'text-green-600' : 'text-red-600'
                      }`}>
                      {application.isBlocked
                        ? `${application.entityName} will regain access to their account`
                        : `${application.entityName} will lose access to their account`
                      }
                    </p>
                  </div>
                </div>
              </div>

              {!application.isBlocked && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Block Reason *
                  </label>
                  <textarea
                    value={blockReason}
                    onChange={(e) => setBlockReason(e.target.value)}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                    placeholder="Provide reason for blocking this account..."
                    required
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    This reason will be logged for audit purposes
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowBlockModal(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleBlockUnblockAccount}
                disabled={(!application.isBlocked && !blockReason.trim()) || actionLoading.blockAccount}
                className={`inline-flex items-center px-4 py-2 font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${application.isBlocked
                    ? 'bg-green-600 text-white hover:bg-green-700'
                    : 'bg-red-600 text-white hover:bg-red-700'
                  }`}
              >
                {actionLoading.blockAccount ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    {application.isBlocked ? 'Unblocking...' : 'Blocking...'}
                  </>
                ) : (
                  <>
                    {application.isBlocked ? (
                      <>
                        <Unlock className="h-4 w-4 mr-2" />
                        Unblock Account
                      </>
                    ) : (
                      <>
                        <Ban className="h-4 w-4 mr-2" />
                        Block Account
                      </>
                    )}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Rejection Modal */}
      {showRejectionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-md w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Reject Lead Generator Application</h3>
              <button
                onClick={() => setShowRejectionModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
                <div className="flex items-center space-x-3">
                  <XCircle className="h-5 w-5 text-red-600" />
                  <div>
                    <h4 className="font-medium text-red-800">Rejecting Application</h4>
                    <p className="text-sm text-red-600">
                      {application.entityName} will be notified about the rejection
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Rejection Reason *
                </label>
                <textarea
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  rows="4"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  placeholder="Provide detailed reason for rejection..."
                  required
                />
                <p className="text-xs text-gray-500 mt-1">
                  This reason will be communicated to the lead generator
                </p>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowRejectionModal(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleRejectLeadGenerator}
                disabled={!rejectionReason.trim() || actionLoading.reject}
                className="inline-flex items-center px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {actionLoading.reject ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Rejecting...
                  </>
                ) : (
                  <>
                    <XCircle className="h-4 w-4 mr-2" />
                    Reject Application
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Request Additional Data Modal */}
      {showRequestModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-lg w-full p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Request Additional Documents</h3>
              <button
                onClick={() => setShowRequestModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            <div className="mb-6">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <div className="flex items-center space-x-3">
                  <MessageSquare className="h-5 w-5 text-blue-600" />
                  <div>
                    <h4 className="font-medium text-blue-800">Request from Lead Generator</h4>
                    <p className="text-sm text-blue-600">
                      {application.entityName} will be notified to submit additional documents
                    </p>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Request Message *
                </label>
                <textarea
                  value={requestMessage}
                  onChange={(e) => setRequestMessage(e.target.value)}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                  placeholder="Explain what additional information or documents are needed..."
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Required Documents *
                </label>
                <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3">
                  {availableDocuments.map((doc, index) => (
                    <label key={index} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        checked={requestDocuments.includes(doc)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setRequestDocuments([...requestDocuments, doc]);
                          } else {
                            setRequestDocuments(requestDocuments.filter(d => d !== doc));
                          }
                        }}
                        className="rounded border-gray-300 text-teal-600 focus:ring-teal-500"
                      />
                      <span className="text-sm text-gray-700">{doc}</span>
                    </label>
                  ))}
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Select the documents that need to be submitted
                </p>
              </div>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowRequestModal(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleRequestAdditionalData}
                disabled={!requestMessage.trim() || requestDocuments.length === 0 || actionLoading.request}
                className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white font-medium rounded-lg hover:from-teal-600 hover:to-cyan-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                {actionLoading.request ? (
                  <>
                    <Loader className="h-4 w-4 mr-2 animate-spin" />
                    Sending Request...
                  </>
                ) : (
                  <>
                    <Send className="h-4 w-4 mr-2" />
                    Send Request
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadGeneratorApplicationDetails;